import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CxImageModule } from '@bbraun/cortex/image';
import { CxMessageModule } from '@bbraun/cortex/message';
import { TranslocoDirective } from '@jsverse/transloco';

import { NoAccessReasons } from '../../definitions/enums/user/no-access-reasons.enum';

@Component({
  selector: 'app-access-missing-permissions',
  imports: [
    CxMessageModule,
    TranslocoDirective,
    CxImageModule
  ],
  templateUrl: './access-missing-permissions.component.html',
  styleUrls: [ './access-missing-permissions.component.sass' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccessMissingPermissionsComponent {
  protected readonly reason = NoAccessReasons.MISSING_PERMISSIONS;
}
